export const SAVE_UGCS = 'SAVE_UGCS';
export const SAVE_UGC_POSTS = 'SAVE_UGC_POSTS';
export const SAVE_UGC_SELECTED_INDEX = 'SAVE_UGC_SELECTED_INDEX';
export const CLEAR_UGC_SELECTED_INDEX = 'CLEAR_UGC_SELECTED_INDEX';
export const SAVE_UGC_SELECTED_FILTER = 'SAVE_UGC_SELECTED_FILTER';
export const CLEAR_UGC_SELECTED_FILTER = 'CLEAR_UGC_SELECTED_FILTER';
export const SAVE_UGC_TRAY = 'SAVE_UGC_TRAY';
export const UGC_RENDERED = "UGC_RENDERED";

/**
 * Saves the entire ugc object into core.ugc.
 *
 * This is useful to initialize ugc to initial, correctly sized arrays
 *
 * Each element in the array should contain
 *  `filters`  (if the UGC has any filters)
 *
 * @param {object} ugc
 */
export function saveUgcs(ugc) {
    return {
        type: SAVE_UGCS,
        payload: ugc
    };
}

export function saveUgcPosts(ugcIndex, ugcResponseData) {
    return {
        type: SAVE_UGC_POSTS,
        payload: {
            index: ugcIndex,
            data: ugcResponseData
        }
    };
}

export function saveUgcSelectedIndex(ugcIndex, trayTileIndex, clickedTileIndex) {
    return {
        type: SAVE_UGC_SELECTED_INDEX,
        payload: {
            index: ugcIndex,
            tray: {
                trayTileIndex: trayTileIndex,
                clickedTileIndex: clickedTileIndex
            }
        }
    };
}

export function clearUgcSelectedIndex(ugcIndex) {
    return {
        type: CLEAR_UGC_SELECTED_INDEX,
        payload: {
            index: ugcIndex,
            tray: {
                trayTileIndex: undefined,
                clickedTileIndex: undefined
            }
        }
    };
}

export function saveUgcSelectedFilter(ugcIndex, filter) {
    return {
        type: SAVE_UGC_SELECTED_FILTER,
        payload: {
            index: ugcIndex,
            filter: filter
        }
    };
}

export function clearUgcSelectedFilter(ugcIndex) {
    return {
        type: CLEAR_UGC_SELECTED_FILTER,
        payload: {
            index: ugcIndex
        }
    };
}

export function saveUgcTray(ugcIndex, data) {
    return {
        type: SAVE_UGC_TRAY,
        payload: {
            index: ugcIndex,
            tray: {
                products: data
            }
        }
    };
}

/**
 * Signal to listeners that the UGC component has finished rendering
 */
export function ugcRendered() {
    return {
        type: UGC_RENDERED
    };
}
